function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "shape0",
  transform: "matrix(0.144 0 0 0.144 0 0.144)",
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.673 2.04L10.023 2.802C10.849 3.617 11.363 4.749 11.363 6C11.363 7.25 10.848 8.382 10.021 9.2L10.673 9.962C11.713 8.962 12.363 7.558 12.363 6.002C12.363 4.444 11.713 3.039 10.673 2.039ZM0 3L0 9L2.804 9L8 12L8 0L2.804 3ZM7 1.732L7 10.268L3.072 8L1 8L1 4L3.072 4Z"
});

var SvgVolumeMedium = function SvgVolumeMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "2.304pt",
    height: "2.016pt",
    viewBox: "0 0 2.304 2.016",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVolumeMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume_medium.b8fab423.svg";
export { ForwardRef as ReactComponent };